import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { EXTERNAL_INSTALLER, TECHNICIAN } from '../../Authentication/constants';
import NOB from '../../../constants/language-strings';
import { SlideContent } from '../components/slide-content';
import { WorkOrderListBottom } from '../components/work-order-list-bottom';
import * as productListAction from '../actions/productList';
import * as popupAction from '../../../components/Popup/actions/popupActions';
import * as workOrderAction from '../actions/workOrderList';
import * as zendeskAction from '../../WorkLog/actions/zendeskActions';
import WorkOrderListSlideContainer from './work-order-list-slide-container';
import { Loader } from 'components';
import styled from 'styled-components';
import { Notification } from '@purpurds/purpur/notification';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
import { purpurColorRed600 } from '@purpurds/tokens/color/variables';
import { ErrorNotification } from 'components/error-notification';
const WorkOrderList = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  max-width: 750px;
  min-height: calc(100vh - 50px);
  padding-bottom: ${spacing.spacing24};
  overflow-x: hidden;
  text-decoration: none;
`;
const StyledNotification = styled(Notification) `
  font-size: ${pxToRem(16)};
  margin-top: ${spacing.spacing12};
  max-width: ${pxToRem(600)};

  @media (max-width: 530px) {
    max-width: ${pxToRem(320)};
    margin: ${spacing.spacing12} ${spacing.spacing8} 0;
  }
`;
const UnfinishedWorkOrderNumber = styled.span `
  margin-left: ${spacing.spacing4};
  margin-right: ${spacing.spacing4};
  color: ${purpurColorRed600};
  font-weight: 600;
`;
const ListNoWorkOrder = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 50px);
`;
const WorkOrderListContainer = ({ endDay, errorMessage = '', isProductListFetching, isWorkOrderListFetching, role = EXTERNAL_INSTALLER, togglePopup, workOrders, previousWorkOrders, requestProductList, requestWorkOrderList, cancelWorkOrderListFetching, saveComment, updateFollowUp, }) => {
    useEffect(() => {
        saveComment('');
        updateFollowUp(false, false, false);
        requestWorkOrderList();
        requestProductList();
        return () => {
            cancelWorkOrderListFetching();
        };
    }, []);
    const isTechnician = role === TECHNICIAN;
    const isExternalInstaller = role === EXTERNAL_INSTALLER;
    const productsLoading = isTechnician ? false : isProductListFetching;
    const isWorkOrderListEmpty = !workOrders.length;
    const unfinishedPastWorkOrders = previousWorkOrders.filter((item) => item.status === 'SENT');
    if (isWorkOrderListFetching || productsLoading) {
        return _jsx(Loader, {});
    }
    ;
    if (errorMessage !== '' && !workOrders.length) {
        return (_jsxs(ListNoWorkOrder, { children: [_jsx(ErrorNotification, { title: NOB.FEEDBACKS.SORRY, text: errorMessage }), _jsx(WorkOrderListBottom, { endDayFunction: endDay, role: role })] }));
    }
    return (_jsxs(WorkOrderList, { children: [!!unfinishedPastWorkOrders.length && (_jsxs(StyledNotification, { heading: "VIKTIG!", id: "unfinished-wo-notification", open: true, status: "warning", children: ["Du har", _jsx(UnfinishedWorkOrderNumber, { children: unfinishedPastWorkOrders.length }), "WO'er som ikke er meldt inn. Vennligst meld inn disse s\u00E5 fort fort du kan! Jobber skal alltid meldes inn samme dag."] })), isExternalInstaller && _jsx(WorkOrderListSlideContainer, {}), isTechnician && (_jsx(SlideContent, { isTechnician: true, workOrdersNotDone: workOrders, isWorkOrderListEmpty: isWorkOrderListEmpty })), _jsx(WorkOrderListBottom, { endDayFunction: endDay, role: role })] }));
};
const mapStateToProps = (state) => ({
    errorMessage: state.workOrders.errorMessage,
    isProductListFetching: state.productList.isFetching,
    isWorkOrderListFetching: state.workOrders.isFetching,
    productList: state.productList.productList,
    role: state.authentication.role,
    workOrders: state.workOrders.workOrders,
    numberOfPrevWorkOrders: state.previousWorkOrders.workOrders.length
        ? state.previousWorkOrders.latestPreviousWorkOrderRequest.totalElements
        : 0,
    previousWorkOrders: state.previousWorkOrders.workOrders,
});
const mapDispatchToProps = (dispatch) => ({
    endDay: (endDay) => dispatch(workOrderAction.endDayFunction({ endDay })),
    requestWorkOrderList: () => dispatch(workOrderAction.requestWorkOrderList()),
    cancelWorkOrderListFetching: () => dispatch(workOrderAction.workOrderListCancel()),
    requestProductList: () => dispatch(productListAction.requestProductList()),
    saveComment: (commentBody) => dispatch(zendeskAction.saveComment(commentBody)),
    togglePopup: (close, popupType) => dispatch(popupAction.togglePopup({ close, popupType })),
    updateFollowUp: (followUp, customerNotHome, allChecked) => dispatch(zendeskAction.setFollowUp({
        followUp,
        customerNotHome,
        allChecked,
    })),
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderListContainer);
